// eslint-disable-next-line
export const VAULT_API_URL = import.meta.env.VITE_API;


export const API_DEFAULT_URL = VAULT_API_URL;

// Googleapis
export const STORAGE_ICONS =
  'https://storage.googleapis.com/dexfinance-images-prd';

